import { getOrgBackend } from "../../../app/backend";
import { RemoteNotificationSetting } from "../../../components/Notification/Domain/NotificationSettings.types";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";

/**
 * GET all enabled notifications for current user
 * @returns all notifications that can be enabled/disabled. includes the translated labels
 * @description This way FE can relay on only returned data and new notifications only need an addition in database.
 */
export function useRemoteFetchNotificationSettings() {
  return useRemoteQuery<RemoteNotificationSetting>({
    queryKey: "userinfo-setting-notification",
    url: `${getOrgBackend()}/user-info/setting/notification`,
    enabled: true
  });
}
